import { FC, useState } from 'react'

import fakeDocumentList, {
  DOCUMENT_TYPES,
  getPaperWorkIcon,
} from '../../../../fakeData/fakeDocumentList'
import LightboxCommonComponent from '../../../common/dialogs/full-screen/LightboxCommonComponent'

import { ISelectedEvent } from '../../../../store/events/eventsSlice'

const EventDetailViewComponentPaperworkElement: React.FC<{
  icon: string
  title: string
  description: string
}> = ({ icon, title, description }) => (
  <div className="w-[150px] grid grid-rows-[auto,1fr,auto]">
    <img className="h-10 mb-2.5 object-cover" src={icon} alt="icon" />
    <h3 className="row-start-2 m-0 text-[15px] font-bold text-SeabiscuitDark200ThemeColor">
      {title}
    </h3>
    <p className="row-start-3 md:mt-2.5 text-[14px] text-[#122B4680]">{description}</p>
  </div>
)

const EventDetailViewComponentPaperwork: FC<{
  selectedEvent: ISelectedEvent
}> = ({ selectedEvent }) => {
  const [showPaperworkPdf, setShowPaperworkPdf] = useState(false)
  const [showPaperworkImages, setShowPaperworkImages] = useState<any>([])

  const openLightboxPaper = (paperworkName: string) => {
    setShowPaperworkImages([])
    const imagesPaperWork = fakeDocumentList?.filter((document) => {
      return document.key === paperworkName
    })
    setShowPaperworkImages(imagesPaperWork[0]?.document_image)
    setShowPaperworkPdf(true)
  }

  return (
    <div>
      <p className=" text-SeabiscuitDark200ThemeColor">
        All paperwork will be completed online during registration
      </p>
      <div className="grid sm:grid-cols-1 xl:grid-cols-4 2xl:grid-cols-6 gap-x-6 gap-y-4 mt-5">
        {selectedEvent.EventPaperwork?.universalOrganizerWaver ? (
          <div
            className="cursor-pointer"
            onClick={() => openLightboxPaper('universalOrganizerWaver')}
          >
            <EventDetailViewComponentPaperworkElement
              icon={getPaperWorkIcon(DOCUMENT_TYPES.GENERAL)}
              title="Universal Entry Waiver"
              description="All personnel on grounds must sign"
            />
          </div>
        ) : null}
        {selectedEvent.EventPaperwork?.USEFWaiverAndReleaseOfLiability ? (
          <div
            className="cursor-pointer"
            onClick={() => openLightboxPaper('USEFWaiverAndReleaseOfLiability')}
          >
            <EventDetailViewComponentPaperworkElement
              icon={getPaperWorkIcon(DOCUMENT_TYPES.USEF)}
              title="USEF Waiver & Release of Liability"
              description="Exhibitor, Trainer, Owner, Coach"
            />
          </div>
        ) : null}

        {selectedEvent.EventPaperwork?.USEFEntryAgreement ? (
          <div className="cursor-pointer" onClick={() => openLightboxPaper('USEFEntryAgreement')}>
            <EventDetailViewComponentPaperworkElement
              icon={getPaperWorkIcon(DOCUMENT_TYPES.USEF)}
              title="USEF Entry Agreement "
              description="Exhibitor, Trainer, Owner, Coach"
            />
          </div>
        ) : null}

        {selectedEvent.EventPaperwork?.USHJAWaiverAndReleaseOfLiability ? (
          <div
            className="cursor-pointer"
            onClick={() => openLightboxPaper('USHJAWaiverAndReleaseOfLiability')}
          >
            <EventDetailViewComponentPaperworkElement
              icon={getPaperWorkIcon(DOCUMENT_TYPES.USHJA)}
              title="USHJA Waiver & Release of Liablity "
              description="Exhibitor, Trainer, Owner, Coach"
            />
          </div>
        ) : null}

        {selectedEvent.EventPaperwork?.USDFWaiverAndReleaseOfLiability ? (
          <div
            className="cursor-pointer"
            onClick={() => openLightboxPaper('USDFWaiverAndReleaseOfLiability')}
          >
            <EventDetailViewComponentPaperworkElement
              icon={getPaperWorkIcon(DOCUMENT_TYPES.USDF)}
              title="USDF Waiver & Release of Liablity "
              description="Exhibitor, Trainer, Owner, Coach"
            />
          </div>
        ) : null}

        {selectedEvent.EventPaperwork?.USEAWaiverAndReleaseOfLiability ? (
          <div
            className="cursor-pointer"
            onClick={() => openLightboxPaper('USEAWaiverAndReleaseOfLiability')}
          >
            <EventDetailViewComponentPaperworkElement
              icon={getPaperWorkIcon(DOCUMENT_TYPES.USEA)}
              title="USEA Waiver & Release of Liablity "
              description="Exhibitor, Trainer, Owner, Coach"
            />
          </div>
        ) : null}
        {/* {
                    props.EventDetails?.competitionPOCName ? <EventDetailViewComponentPointOfContactElement
                        title="Point of Contact"
                        icon={User}
                        details={props.EventDetails?.competitionPOCName ?? "N/A"}
                    /> : null
                }

                {
                    props.EventDetails?.competitionPOCPhone ? <EventDetailViewComponentPointOfContactElement
                        title="Phone"
                        icon={Phone}
                        type="phone"
                        details={props.EventDetails?.competitionPOCPhone ?? "N/A"}
                    /> : null
                } */}
        <LightboxCommonComponent
          onClose={() => setShowPaperworkPdf(false)}
          visible={showPaperworkPdf}
          slides={showPaperworkImages.map((showPaperwork: string) => {
            return { src: showPaperwork }
          })}
        />
      </div>
    </div>
  )
}

export default EventDetailViewComponentPaperwork
